import PageHero from '../components/UI/PageHero';
import AboutFull from '../components/About/AboutFull';
import Stats from '../components/Stats/Stats';
import Fleet from '../components/Fleet/Fleet';
import ContactCTA from '../components/ContactCTA/ContactCTA';
import { IMG } from '../data/siteData';

export default function About() {
  return (
    <>
      <PageHero
        eyebrow="About Ambadykannan Transport"
        title="Two Decades Of Heavy Transport"
        subtitle="From a single truck on the Erode–Kochi route to a cross-state freight network — this is our story."
        bg={IMG.nightStreet}
      />
      <AboutFull />
      <Stats />
      <Fleet />
      <ContactCTA />
    </>
  );
}
